module.exports = __webpack_public_path__ + "media/images/icons/material/document-minimalist-9846d1a340826ac9859b3d919db48f41.svg";